import React from 'react'

const IntroProduct = () => {
  return (
   <div className="pcb-container">
      <div className="pcb-text">
        <h2>Product Focus & Expertise</h2>
        <p style={{ fontSize: '19px', lineHeight: '1.6' ,color:"black"}}>
       At Automotive Devices, our product focus is centered on delivering PCBA solutions that exceed industry standards for quality, performance, and reliability. From rapid prototyping at our San Jose facility to full-scale production, we are equipped with advanced manufacturing technologies and a team of highly skilled professionals who ensure every product is crafted with precision and attention to detail.

Our expertise spans a wide range of industries, allowing us to meet the specific and often complex requirements of each project we undertake. Whether it’s automotive, industrial automation, medical electronics, or consumer technology, we tailor our processes to match the unique demands of each sector.

We take pride in staying at the forefront of technological advancements by continuously upgrading our capabilities and training our team. This forward-thinking approach enables us to confidently handle intricate designs, multilayer boards, and a variety of materials—ensuring durability, performance, and compliance with global quality standards.
        </p>
      </div>
      <div className="pcb-image">
        <img src='/images (1).jpeg' alt="PCB Assembly" />
      </div>
    </div>
  )
}

export default IntroProduct
